var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextAndImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.2222V6.77778C21 5.8 20.2 5 19.2222 5H12.6084C12.6084 12.6084 12.6084 12.6084 5 12.6084V19.2222C5 20.2 5.8 21 6.77778 21H19.2222C20.2 21 21 20.2 21 19.2222ZM9.88889 14.3333L12.1111 17.0089L15.2222 13L19.2222 18.3333H6.77778L9.88889 14.3333Z",
    fill: "#2990FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4V5.4H4.36842V11H5.78947V5.4H8.15789V4H2ZM11 6.33333H6.73684V7.73333H8.15789V11H9.57895V7.73333H11V6.33333Z",
    fill: "#2990FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextAndImage);
export default __webpack_public_path__ + "static/media/textAndImage.4b29b6f5cdc96bb9752d940c436f75f1.svg";
export { ForwardRef as ReactComponent };